import {StylesParamsType} from '../../types/createStylesParams'
import {
  buttonDefaultStylesParams,
  buttonHoverStylesParams,
  ButtonDefaultStylesParams,
  ButtonHoverStylesParams,
} from '../../components-shared/Settings/Button/stylesParams'
import {
  formLineStylesParams,
  formBoxStylesParams,
  FormLineStylesParams,
  FormBoxStylesParams,
} from '../../components-shared/Settings/FormDesign/stylesParams'
import {
  areasDefaultStylesParams,
  areasHoverStylesParams,
  areasSelectedStylesParams,
  AreasDefaultStylesParams,
  AreasHoverStylesParams,
  AreasSelectedStylesParams,
} from '../Reservations/Settings/Tabs/Design/Areas/stylesParams'

import {generalStyleParams, GeneralStylesParams} from './Settings/Tabs/Design/General/stylesParams'
import {
  areasLayoutStylesParams,
  AreasLayoutStylesParams,
  layoutStylesParams,
  LayoutStylesParams,
} from './Settings/Tabs/Layout/stylesParams'

export type StylesParams = GeneralStylesParams &
  ButtonDefaultStylesParams &
  ButtonHoverStylesParams &
  FormLineStylesParams &
  FormBoxStylesParams &
  LayoutStylesParams &
  AreasLayoutStylesParams &
  AreasDefaultStylesParams &
  AreasHoverStylesParams &
  AreasSelectedStylesParams

export const stylesParams: StylesParamsType<StylesParams> = {
  ...generalStyleParams,
  ...formLineStylesParams,
  ...formBoxStylesParams,
  ...buttonDefaultStylesParams,
  ...buttonHoverStylesParams,
  ...layoutStylesParams,
  ...areasLayoutStylesParams,
  ...areasDefaultStylesParams,
  ...areasHoverStylesParams,
  ...areasSelectedStylesParams,
}

export default stylesParams
